import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { DiscoveryLayout } from '@/components/discovery/discovery-layout';
import { sectionOf } from '@/components/discovery/discovery-logic';

/**
 * Engagement -> Discovery (T-0185, E12-F02). The module's layout route:
 * the frame, the module-off state and the one-direction routing live in
 * `DiscoveryLayout`; each tab is a child route.
 *
 *   /discovery            Overview: the guide, then the dashboard
 *   /discovery/setup      first-run setup (only before discovery starts)
 *   /discovery/sessions   ?interview=<id> | ?person=<id>   (T-0186, T-0187)
 *   /discovery/findings   ?area=<id|all>&status=<status>   (T-0188)
 *   /discovery/maps       (T-0189)
 *   /discovery/signoff    (T-0191; opened from the Overview card)
 *
 * The sidebar lists Discovery only when the engagement's Discovery module
 * is on; the API answers not_found otherwise, which the frame says plainly.
 */
export const Route = createFileRoute('/engagements/$engagementId/discovery')({
  component: DiscoveryRoute,
});

function DiscoveryRoute() {
  const { engagementId } = Route.useParams();
  const { pathname } = useLocation();
  return (
    <DiscoveryLayout key={engagementId} engagementId={engagementId} section={sectionOf(pathname)}>
      <Outlet />
    </DiscoveryLayout>
  );
}
